import { Moon } from 'lucide-react'
import { useState } from 'react'
import { useNotification } from '../contexts/NotificationContext'
import { relaunchGroup } from '../services/groupService'
import { Button } from './ui/button'

// Owner-only. A public group with no tournaments for 90 days leaves the
// public list a week after the owner is warned (owner 2026-10-07); members
// still see it, and one tap lists it again.
export default function GroupQuietBanner({ groupId, status, onRelaunched }) {
  const notify = useNotification()
  const [busy, setBusy] = useState(false)

  if (status !== 'warned' && status !== 'quiet') return null

  const handleRelaunch = async () => {
    setBusy(true)
    try {
      await relaunchGroup({ groupId })
      notify.success('Relaunched! Your group is back in the public list.')
      onRelaunched?.()
    } catch (err) {
      console.error('Error relaunching group:', err)
      notify.error(err.message || 'Failed to relaunch group')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="mb-6 flex flex-col gap-3 rounded-lg border bg-muted/40 p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <Moon className="h-5 w-5 text-muted-foreground flex-shrink-0 mt-0.5" />
        <p className="text-sm">
          {status === 'quiet'
            ? "Your group has gone quiet, so it's no longer in the public groups list. Members can still find it."
            : 'Your group has had no tournaments for a while and will leave the public groups list soon.'}
        </p>
      </div>
      <Button onClick={handleRelaunch} disabled={busy} className="flex-shrink-0">
        {busy ? 'Relaunching…' : 'Relaunch group'}
      </Button>
    </div>
  )
}
